import {useQuery} from 'react-query';
import {PaymentMethodValues} from '../../../pages/shopping-basket/cash-payment/utils/helpers';
import {CreditPaymentResponse} from '../../../pages/shopping-basket/cash-payment/utils/types';
import {getStoreOrderCreditTransactionPrice} from './getStoreOrderCreditTransactionPrice';

const useGetStoreOrderCreditTransactionPrice = ({
  storeOrderGuid,
  handleAfterSuccess,
  paymentType,
  enabled = true,
}: {
  storeOrderGuid?: string;
  handleAfterSuccess?: (data: CreditPaymentResponse) => void;
  paymentType?: PaymentMethodValues;
  enabled?: boolean;
}) => {
  const {data, isLoading, refetch, isSuccess, isFetching} =
    useQuery<CreditPaymentResponse>(
      ['get-store-order-credit-transaction-price', storeOrderGuid, paymentType],
      () => getStoreOrderCreditTransactionPrice(storeOrderGuid, paymentType),
      {
        enabled: Boolean(storeOrderGuid) && enabled,
        onSuccess: data => handleAfterSuccess?.(data),
      },
    );
  return {data, isLoading, refetch, isSuccess, isFetching};
};

export default useGetStoreOrderCreditTransactionPrice;
